var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('Common'),_c('div',{staticClass:"dashboard-container"},[_c('Sidebar'),_c('TopBar'),_c('Content')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }